import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicNumericalMethods = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="SUMMARY"
      videos={[]}
      takeaways={[
        { text: "This is the module where you get majorly numerical type questions (if you practice well or if you do with some patience in exam these are very easy)" },
        { text: "Remember all the flow charts related to multiplication and division algorithms and remember the theory part related to floating point representations" }
      ]}
      questions={[]}
      exampleVideos={[]}
    />
);
}

export default ModuleSubtopicNumericalMethods;